import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

interface ChangePasswordModalProps {
  open: boolean;
  onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  open,
  onClose,
}) => {
  const [resetRequestSent, setResetRequestSent] = useState<boolean>(false);
  const [resetRequestSucceeded, setResetRequestSucceeded] = useState<boolean>(false);
  const [resetRequestError, setResetRequestError] = useState<string>('');

  const { user, isAuthenticated, isLoading } = useAuth0();

  const handlePasswordResetRequest = async () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const url = `https://${process.env.REACT_APP_Auth0Domain}/dbconnections/change_password`;
    const options: RequestInit = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        client_id: process.env.REACT_APP_Auth0ClientID,
        connection: process.env.REACT_APP_Auth0Connection,
        email: user?.email
      })
    };

    try {
      setResetRequestSent(true);
      const response = await fetch(url, options);
      if (response.ok) {
        setResetRequestSucceeded(true);
      } else {
        throw response.statusText ?? 'Unexpected error requesting password reset'
      }
    } catch (e: Error | any) {
      setResetRequestError(e.toString());
    }
  }
  
  const renderForm = () => {
    let content = (
      <Button variant="contained" onClick={handlePasswordResetRequest}>
        Request Password Reset Email
      </Button>
    );

    if (resetRequestSucceeded) {
      content = <div>A link to reset your password was sent to {user?.email ?? 'your email address'}.</div>;
    } else if (resetRequestError) {
      content = <div>Encountered error while requesting password reset email.</div>;
    } else if (resetRequestSent) {
      content = <div>Requesting...</div>;
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
        {content}

        <Button style={{ marginTop: '12px' }} onClick={onClose}>
          Close
        </Button>
      </div>
    );
  }

  if (!user?.email || !isAuthenticated || isLoading) return <div>Loading...</div>;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        paddingTop: "16px",
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <Typography
          variant="h6"
          noWrap
          component="div"
          fontFamily={'Helvetica Neue LT Std'}
          fontWeight={'300'}
          fontSize={28}
          color={'#1A1A1A'}
          sx={{ mb: 2 }}
        >
          Change Password
        </Typography>
        {renderForm()}
      </Box>
    </Modal>
  );
};

export default ChangePasswordModal;